import { LeadGenBannerSection, SectionListRendererWrapper } from './SectionListRenderer.styles';

import { ContentTypeMapping, ContentTypeName } from '@/constants';
import { useGlobalState } from '@/hooks';
import { ButtonFunctionKey } from '@/interfaces';
import { capitalize } from '@/utils';

interface ISectionListRendererProps {
  // biome-ignore lint/suspicious/noExplicitAny: Contentful section list has dynamic shape
  sectionList: any[];
  hideSpacingBetweenSections?: boolean;
}

const SectionListRenderer: React.FC<ISectionListRendererProps> = ({ sectionList, hideSpacingBetweenSections }) => {
  const { isLoggedIn } = useGlobalState();

  return (
    <SectionListRendererWrapper hideSpacingBetweenSections={hideSpacingBetweenSections}>
      {sectionList.map((section, index) => {
        const sectionTypeName = capitalize(section.__typename) as ContentTypeName;
        const SectionComponent = ContentTypeMapping[sectionTypeName];

        if (!SectionComponent) {
          return null;
        }

        switch (sectionTypeName) {
          case ContentTypeName['LeadGenBanner']: {
            // biome-ignore lint/suspicious/noExplicitAny: button shape is dynamic
            const isPopUpButton = section?.buttons?.some((button: any) => button.function === ButtonFunctionKey.PopUp);
            const isHideLoggedInUser = isPopUpButton && isLoggedIn;
            return (
              <LeadGenBannerSection key={index} variant={section.variant} isHideLoggedInUser={isHideLoggedInUser}>
                <SectionComponent {...section} />
              </LeadGenBannerSection>
            );
          }

          default:
            return <SectionComponent key={index} {...section} />;
        }
      })}
    </SectionListRendererWrapper>
  );
};

export default SectionListRenderer;
